import React from 'react'
import './ContentPage.scss'
import MetaTags, { getLegalPageStructuredData } from '../ui/MetaTags'

const ContentPage = ({
  data,
  pageTitle = "Content",
  metaTitle,
  metaDescription,
  url
}) => {
  // Early return if no data is provided
  if (!data) {
    return <div>Loading...</div>
  }

  // Convert data to simple structure matching ImprintPage
  const renderContent = () => {
    // Handle new simplified content array structure
    if (data.content && Array.isArray(data.content)) {
      return data.content.map((section, index) => (
        <React.Fragment key={index}>
          {section.title && <h2>{section.title}</h2>}
          {section.text && <p>{section.text}</p>}
          {section.items && section.items.map((item, itemIndex) => (
            <React.Fragment key={itemIndex}>
              {item.title && <h3>{item.title}</h3>}
              {item.text && <p>{item.text}</p>}
              {item.source && (
                <p><strong>Source:</strong> {item.source}</p>
              )}
            </React.Fragment>
          ))}
        </React.Fragment>
      ));
    }

    // Handle legacy sections object structure
    if (data.sections && !data.content) {
      return Object.values(data.sections).map((section, index) => (
        <React.Fragment key={index}>
          {section.title && <h2>{section.title}</h2>}
          {section.text && <p>{section.text}</p>}
          {section.subsections && section.subsections.map((subsection, subIndex) => (
            <React.Fragment key={subIndex}>
              {subsection.title && <h3>{subsection.title}</h3>}
              {subsection.text && <p>{subsection.text}</p>}
              {subsection.source && (
                <p><strong>Source:</strong> {subsection.source}</p>
              )}
            </React.Fragment>
          ))}
        </React.Fragment>
      ));
    }

    return null;
  };

  const resolvedUrl =
    url || `https://www.elodiecarstensen.com/${pageTitle.toLowerCase().replace(/\s+/g, '-')}`
  const resolvedTitle = metaTitle || `${pageTitle} - Elodie Carstensen`

  return (
    <>
      <MetaTags
        title={resolvedTitle}
        description={metaDescription || `${pageTitle} information for Elodie Carstensen.`}
        url={resolvedUrl}
        type="article"
        structuredData={getLegalPageStructuredData(resolvedTitle, resolvedUrl)}
      />
      <div className="content-page">
        <h1>{pageTitle}</h1>
        {renderContent()}
      </div>
    </>
  )
}

export default ContentPage